import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltMediaSourceSettingsAudioWireframe from './VeltMediaSourceSettingsAudioWireframe/VeltMediaSourceSettingsAudioWireframe';
import VeltMediaSourceSettingsVideoWireframe from './VeltMediaSourceSettingsVideoWireframe/VeltMediaSourceSettingsVideoWireframe';
var VeltMediaSourceSettingsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsWireframe.Audio = VeltMediaSourceSettingsAudioWireframe;
VeltMediaSourceSettingsWireframe.Video = VeltMediaSourceSettingsVideoWireframe;
export default VeltMediaSourceSettingsWireframe;
